/* 
	顶部导航路由 
 */
import Layout from '@/pages/layout'
// 登录相关
export const common = [
	{
		path:"/login",
		name:"login",
		meta: {
			title: '新时代党建后台登录',
			requiresAuth:[1,2,3]
		},
		component: () => import('@/pages/login')
	},
	{
		path:"*",
		name:"error",
		meta:{
			title:"错误",
			requiresAuth:[1,2,3]
		},
		component: () => import('@/pages/error') 
	}
]